// Converts raw "function_name" values returned by the logs API into
// user-friendly labels by cleaning up the raw name (no renaming).

// Converts a raw function_name (typically camelCase or snake_case) into a
// human-readable Title Case string, e.g. "resetSubscriptionEndDate" ->
// "Reset Subscription End Date".
export const prettifyFunctionName = (raw) => {
    if (raw === undefined || raw === null || raw === "") return "";
    return String(raw)
        // snake_case and kebab-case to spaces
        .replace(/[_-]+/g, " ")
        // camelCase boundaries to spaces
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/\s+/g, " ")
        .trim()
        .replace(/\b\w/g, (c) => c.toUpperCase());
};

// Returns the friendly label for a function_name: the raw value cleaned up.
export const getFunctionNameLabel = (functionName) => {
    return prettifyFunctionName(functionName);
};

export default getFunctionNameLabel;
